import { PostRequest } from "../../../plugins/https";
import { setToken } from "./action";
import { SET_TOKEN } from "./actionType";

export const loginUser = (email, password) => async (dispatch) => {
  try {
    const route = process.env.NEXT_PUBLIC_BASE_URL;
    const res = await PostRequest(`auth/login`, { email, password });
    // Backend sets httpOnly cookie and returns user details
    if (res?.data?.data?.details) {
      const user = res.data.data.details;
      localStorage.setItem("user", JSON.stringify(user));
      dispatch(setToken(user));
      return { success: true, user };
    } else {
      // fallback: clear any stored user
      localStorage.removeItem("user");
      dispatch(setToken(undefined));
      return { success: false, message: res?.data?.message || "No user data" };
    }
  } catch (error) {
    console.error("Login failed", error);
    return { success: false, message: error?.message || "Login failed" };
  }
};

const initialState = {
  token: "",
};

export const loginReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_TOKEN:
      return {
        ...state,
        token: action.payload,
      };

    default:
      return state;
  }
};
